import get from 'lodash/get'
import has from 'lodash/has'

export const toFloatByPath = <DataT = Record<string, number>>(data: DataT, path: string, fixed: number = 1, removeLeadingZero: boolean = false, defaultValue: string | number = '-'): string | number => {
  if (!data) {
    return defaultValue
  }

  if (!has(data, path)) {
    useLogger().warn(`Path ${path} not found in data`, { data })

    return defaultValue
  }

  return NumberFormat.create(get(data, path, 0) as number).formatAfterDot(fixed, removeLeadingZero)
}
